import create from "zustand";

export const useStore = create((set, get) => ({
  selectedBlog: null,
  blogs: null,
  getBlogs: (payload) => {
    // localStorage.setItem("blogs", JSON.stringify(payload))
    set({ blogs: payload });
  },
  selectBlog: (payload) => {
    set({
      selectedBlog: payload,
    });
  },
}));
